import React, { Fragment, useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { getRequestSampleTrackingList } from "helpers/app-backend/sampletracking_backend_helper"
import { formatTimeAgoVN } from "helpers/utilities"

const FooterRight = ({ t }) => {
  const [data, setData] = useState([])

  const onFetchSampleComplete = async () => {
    const res = await getRequestSampleTrackingList({ size: 3, isSendTest: false, page: 1 })
    setData(res.data)
  }
  useEffect(() => {
    onFetchSampleComplete()
  }, [])

  return (
    <Fragment>
      <Card className="general-dashboard-footer-right" style={{
        height: 'auto',
        minHeight: 'calc(100vh - 180px)',
        maxHeight: 'none',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 0
      }}>
        <CardHeader
          style={{
            textAlign: "center",
            background: "#fff",
            paddingBottom: 0,
            fontSize: 15,
            fontWeight: 600,
            flexShrink: 0
          }}
        >
          Các mẫu đã hoàn thành
        </CardHeader>
        <CardBody
          style={{
            flex: 1,
            overflowY: "auto",
            paddingBottom: 0,
            maxHeight: 'calc(100vh - 240px)' // Account for header and padding
          }}
        >
          <ul className="list-group list-group-flush">
            {data.map((item, index) => (
              <li key={index} className="list-group-item">
                <div className="py-2">
                  <Row>
                    <Col lg="1">
                      <i
                        style={{ fontSize: 34, color: "#7bb8f4" }}
                        className={"far fa-file-alt"}
                      ></i>
                    </Col>
                    <Col lg="11">
                      <Row>
                        <Col lg="12">
                          REQ ID:{" "}
                          <span style={{ color: "blue" }}>
                            <Link
                              to={`/TestResult/${item.requestId}?tab=1`}
                              target="_blank"
                            >
                              {item.requestId}
                            </Link>
                          </span>{" "}
                          PID: {item.patientId} - {item.patientName}
                        </Col>
                        <Col
                          lg="12"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ display: "flex", marginTop: 8 }}>
                            <div key={item.sid}>
                              <label
                                key={item.sid}
                                data-tip
                                data-for={`${item.sid}-${item.sid}`}
                                style={{
                                  color: "#5F5F5F",
                                  backgroundColor: "#fff",
                                  padding: "1px 5px",
                                  marginRight: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #808080",
                                }}
                              >
                                {item.sid}
                              </label>
                              <ReactTooltip
                                id={`${item.sid}-${item.sid}`}
                                place="right"
                                effect="solid"
                              >
                                {item.sampleTypeName} - {item.sampleType}
                              </ReactTooltip>
                            </div>
                          </div>
                          <div style={{ marginTop: 15 }}>
                            {formatTimeAgoVN(item.collectionTime)}
                            <Button
                              color="light"
                              size="sm"
                              style={{ marginTop: -15, marginLeft: 10 }}
                            >
                              ...
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </li>
            ))}
          </ul>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export default withTranslation(["testConfig", "message"])(FooterRight)
